var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWarningRounded = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 46,
  height: 46,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 46,
  height: 46,
  fill: "#FFF5E2",
  rx: 23
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 25,
  height: 25,
  x: 10.5,
  y: 10.5,
  fill: "#FFA617",
  rx: 12.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M17.353 29.75h11.295a1.5 1.5 0 0 0 1.297-2.25l-5.647-9.757a1.5 1.5 0 0 0-2.595 0L16.055 27.5a1.5 1.5 0 0 0 1.298 2.25M23 24.5a.75.75 0 0 1-.75-.75v-1.5c0-.413.338-.75.75-.75.413 0 .75.337.75.75v1.5c0 .413-.337.75-.75.75m.75 3h-1.5V26h1.5z"
})));
export { SvgWarningRounded as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NiIgaGVpZ2h0PSI0NiIgZmlsbD0ibm9uZSI+PHJlY3Qgd2lkdGg9IjQ2IiBoZWlnaHQ9IjQ2IiBmaWxsPSIjRkZGNUUyIiByeD0iMjMiLz48cmVjdCB3aWR0aD0iMjUiIGhlaWdodD0iMjUiIHg9IjEwLjUiIHk9IjEwLjUiIGZpbGw9IiNGRkE2MTciIHJ4PSIxMi41Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE3LjM1MyAyOS43NWgxMS4yOTVhMS41IDEuNSAwIDAgMCAxLjI5Ny0yLjI1bC01LjY0Ny05Ljc1N2ExLjUgMS41IDAgMCAwLTIuNTk1IDBMMTYuMDU1IDI3LjVhMS41IDEuNSAwIDAgMCAxLjI5OCAyLjI1TTIzIDI0LjVhLjc1Ljc1IDAgMCAxLS43NS0uNzV2LTEuNWMwLS40MTMuMzM4LS43NS43NS0uNzUuNDEzIDAgLjc1LjMzNy43NS43NXYxLjVjMCAuNDEzLS4zMzcuNzUtLjc1Ljc1bS43NSAzaC0xLjVWMjZoMS41eiIvPjwvc3ZnPg==";